import { render } from "./PreencherOSPanel.vue?vue&type=template&id=ed006a96&scoped=true&ts=true"
import script from "./PreencherOSPanel.vue?vue&type=script&lang=ts"
export * from "./PreencherOSPanel.vue?vue&type=script&lang=ts"

import "./PreencherOSPanel.vue?vue&type=style&index=0&id=ed006a96&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed006a96"]])

export default __exports__